import { render, staticRenderFns } from "./VIDEO_TEST.vue?vue&type=template&id=f56d1290&"
import script from "./VIDEO_TEST.vue?vue&type=script&lang=js&"
export * from "./VIDEO_TEST.vue?vue&type=script&lang=js&"
import style0 from "./VIDEO_TEST.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports